import { render, staticRenderFns } from "./MasterUserRoadmapDetails.vue?vue&type=template&id=4f81dd68"
import script from "./MasterUserRoadmapDetails.vue?vue&type=script&lang=js"
export * from "./MasterUserRoadmapDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports